import { render } from "./ManageUpdateCycleIcon.vue?vue&type=template&id=ab396424&ts=true"
import script from "./ManageUpdateCycleIcon.vue?vue&type=script&lang=ts"
export * from "./ManageUpdateCycleIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__